const urlMap = new WeakMap();

/**
 * A thin wrapper around Response that allows us to set a URL on the response.
 */
export class MockResponse extends Response {
  constructor(body: BodyInit | null, init: ResponseInit = {}, url: string) {
    super(body, init);
    const href = url ? new URL(url).href : '';
    urlMap.set(this, href);
  }

  get url() {
    return urlMap.get(this) ?? '';
  }

  set url(val) {
    const href = val ? new URL(val).href : '';
    urlMap.set(this, href);
  }
}
